import React, { useState, useEffect } from "react";
import { styled, alpha } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Cookies from "universal-cookie";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { setLanguage } from "../../Redux/reduxToolkit";

// Styled Menu
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 120,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, " +
      "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, " +
      "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, " +
      "rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      fontSize: '14px',
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function CustomizedMenus() {
  const cookies = new Cookies();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState("English");

  // Load saved language from cookies
  useEffect(() => {
    const savedLang = cookies.get("activeLanguage");
    if (savedLang) {
      const label = savedLang === "fr" ? "French" : "English";
      setSelectedLanguage(label);
      dispatch(setLanguage(savedLang));
    }
  }, [dispatch]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Change language + save in cookies
  const changeLanguage = (langCode, label) => {
    dispatch(setLanguage(langCode));
    setSelectedLanguage(label);
    cookies.set("activeLanguage", langCode, { path: "/" });
    handleClose();
  };

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={anchorEl ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={anchorEl ? "true" : undefined}
        variant="text"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        style={{
          color: "#405261",
          border: "1px solid #D5DCE1",
          fontSize: "14px",
          fontWeight: "500",
          borderRadius: "8px",
          // padding: "11px",
          height: "40px",
          width: "120px",
          textTransform: "capitalize",
        }}
      >
        {selectedLanguage}
      </Button>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => changeLanguage("en", "English")}>
          English
        </MenuItem>
        <MenuItem onClick={() => changeLanguage("fr", "French")}>
          French
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
